import React, { useState } from "react";
import theme from "../../../styles/theme";

const BadgesSplitView = ({ tabs , containerStyle = {} }) => {
  const [activeTab, setActiveTab] = useState(0);

  return (
    <div style={{ width: "100%", fontFamily: theme.fonts.body, ...containerStyle }}>
      {/* Onglets */}
      <div
        style={{
          display: "flex",
          borderBottom: `1px solid ${theme.colors.borders.default}`,
          gap: theme.spacing.sm,
          
        }}
      >
        {tabs.map((tab, index) => {
          const isActive = activeTab === index;

          return (
            <div
              key={index}
              onClick={() => setActiveTab(index)}
              style={{
                display: "flex",
                alignItems: "center",
                gap: theme.spacing.xs,
                padding: `${theme.spacing.sm}px ${theme.spacing.md}px`,
                cursor: "pointer",
                fontSize: theme.fontSizes.sm,
                fontWeight: isActive
                  ? theme.fontWeights.semiBold
                  : theme.fontWeights.normal,
                color: isActive
                  ? theme.colors.text.primary
                  : theme.colors.text.body,
                borderBottom: isActive
                  ? `3px solid ${theme.colors.text.primary}`
                  : "3px solid transparent",
                transition: "color 0.2s ease, border-bottom 0.2s ease",
              }}
            >
              {/* Libellé onglet */}
              <span>{tab.label}</span>

              {/* Badge optionnel */}
              {tab.badge !== undefined && (
                <span
                  style={{
                    padding: "2px 8px",
                    fontSize: theme.fontSizes.xs,
                    borderRadius: theme.borders.radius.full,
                    backgroundColor: isActive
                      ? theme.colors.background.selected
                      : theme.colors.background.panel,
                    color: isActive
                      ? theme.colors.text.primary
                      : theme.colors.text.small,
                    border: `1px solid ${theme.colors.borders.default}`,
                    fontWeight: theme.fontWeights.medium,
                    transition: "background-color 0.2s ease, color 0.2s ease",
                  }}
                >
                  {tab.badge}
                </span>
              )}
            </div>
          );
        })}
      </div>

      {/* Contenu */}
      <div
        style={{
          padding: theme.spacing.md,
          backgroundColor: containerStyle.background || theme.colors.background.surface,
          fontSize: theme.fontSizes.md,
          color: theme.colors.text.body,
          
          
        }}
      >
        {tabs[activeTab].content}
      </div>

    </div>
  );
};

export default BadgesSplitView
